import {useInternationalization} from "@progress/kendo-react-intl";

const useExcelExportFormat = () => {
  const intl = useInternationalization();

  function numberFormat(scale : number) : string {
    let symbols = _numberSymbols();
    let format = `#${symbols.group}##0${_decimalFormat(scale, symbols)}`;
    return `${format};${symbols.negativeSign}${format}`;
  }

  function percentFormat(scale : number) : string {
    let symbols = _numberSymbols();
    let format = `#${symbols.group}##0${_decimalFormat(scale, symbols)}${symbols.percentSign}`;
    return `${format};${symbols.negativeSign}${format}`;
  }

  function _decimalFormat(scale : number, symbols : any) : string {
    let format = scale > 0 ? symbols.decimal : '';
    for (let i = 0; i < scale; i++)
      format += '0';
    return format;
  }

  function _numberSymbols() {
    let symbols = intl.numberSymbols();
    return {
      group: symbols.group || ',',
      decimal: symbols.decimal || '.',
      percentSign: symbols.percentSign || '%',
      negativeSign: symbols.negativeSign || '-'
    };
  }

  return {
    numberFormat,
    percentFormat
  };
}

export default useExcelExportFormat;